var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h1", [
      _vm._v(
        " " +
          _vm._s(
            true != null
              ? _vm.$t("settings.users.userEdit")
              : _vm.$t("settings.users.userNew")
          ) +
          " "
      )
    ]),
    _c(
      "div",
      { staticClass: "mt-3 elevation-12 grey lighten-4" },
      [
        _c("user-settings-menu"),
        _c(
          "v-card",
          [
            _c(
              "v-card-text",
              [
                _c("h2", [
                  _vm._v(_vm._s(_vm.$t("settings.users.hasPermissions")))
                ]),
                _c("v-data-table", {
                  attrs: {
                    headers: _vm.headersAssignedPerms,
                    items: _vm.authItems,
                    "hide-default-footer": "",
                    "footer-props": {
                      "items-per-page-options": [
                        {
                          text: "$vuetify.dataIterator.rowsPerPageAll",
                          value: -1
                        }
                      ]
                    }
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "item",
                      fn: function(props) {
                        return [
                          _c("tr", [
                            _c("td", { staticClass: "text-left" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    props.item.type == 2
                                      ? _vm.$t("global.permission")
                                      : _vm.$t("global.role")
                                  ) +
                                  " "
                              )
                            ]),
                            _c("td", { staticClass: "text-left" }, [
                              _vm._v(_vm._s(props.item.item_name))
                            ]),
                            _c(
                              "td",
                              { staticClass: "text-left" },
                              [
                                _c(
                                  "v-tooltip",
                                  {
                                    attrs: { top: "" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function(ref) {
                                            var on = ref.on
                                            return [
                                              _c(
                                                "span",
                                                _vm._g({}, on),
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      props.item.deputy_by_id !=
                                                        null
                                                        ? _vm.$t("global.yes")
                                                        : _vm.$t("global.no")
                                                    ) + " "
                                                  ),
                                                  props.item.deputy_by_id !=
                                                  null
                                                    ? _c(
                                                        "v-icon",
                                                        {
                                                          staticStyle: {
                                                            "font-size": "16px"
                                                          }
                                                        },
                                                        [_vm._v("info")]
                                                      )
                                                    : _vm._e()
                                                ],
                                                1
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(props.item.from_date) +
                                        " - " +
                                        _vm._s(props.item.to_date) +
                                        " " +
                                        _vm._s(_vm.$t("global.by")) +
                                        " " +
                                        _vm._s(props.item.deputy_by_name) +
                                        " "
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _c("td", { staticClass: "text-left" }, [
                              _vm._v(_vm._s(props.item.item_description))
                            ]),
                            _c(
                              "td",
                              { staticClass: "text-left" },
                              [
                                _c(
                                  "v-tooltip",
                                  {
                                    attrs: { bottom: "" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function(ref) {
                                            var on = ref.on
                                            return [
                                              _c(
                                                "v-btn",
                                                _vm._g(
                                                  {
                                                    attrs: {
                                                      disabled:
                                                        _vm.$store.getters[
                                                          "Ajax/loading"
                                                        ],
                                                      icon: ""
                                                    },
                                                    nativeOn: {
                                                      click: function($event) {
                                                        return _vm.removeAuthItem(
                                                          props.item
                                                        )
                                                      }
                                                    }
                                                  },
                                                  on
                                                ),
                                                [
                                                  _c("v-icon", [
                                                    _vm._v("clear")
                                                  ])
                                                ],
                                                1
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("global.delete")) +
                                        " "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ])
                        ]
                      }
                    },
                    {
                      key: "no-data",
                      fn: function() {
                        return [
                          _c(
                            "v-alert",
                            { attrs: { color: "error", icon: "warning" } },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("settings.users.noPermission")
                                  ) +
                                  " "
                              )
                            ]
                          )
                        ]
                      },
                      proxy: true
                    }
                  ])
                }),
                _c(
                  "v-row",
                  {
                    staticClass: "mt-5 md-0",
                    staticStyle: { "margin-bottom": "15px" }
                  },
                  [
                    _c("v-col", [
                      _c("h3", [
                        _vm._v(_vm._s(_vm.$t("settings.users.addPermissions")))
                      ])
                    ]),
                    _c("v-spacer"),
                    _c(
                      "v-col",
                      { attrs: { cols: "3" } },
                      [
                        _c("v-text-field", {
                          attrs: {
                            label: _vm.$t("global.search"),
                            "append-icon": "search",
                            "hide-details": "",
                            "single-line": ""
                          },
                          model: {
                            value: _vm.search,
                            callback: function($$v) {
                              _vm.search = $$v
                            },
                            expression: "search"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c("v-data-table", {
                  attrs: {
                    headers: _vm.headers,
                    items: _vm.availableAuthItems,
                    search: _vm.search
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "item",
                      fn: function(props) {
                        return [
                          _c("tr", [
                            _c("td", { staticClass: "text-left" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    props.item.type == 2
                                      ? _vm.$t("global.permission")
                                      : _vm.$t("global.role")
                                  ) +
                                  " "
                              )
                            ]),
                            _c("td", { staticClass: "text-left" }, [
                              _vm._v(_vm._s(props.item.translated_name))
                            ]),
                            _c("td", { staticClass: "text-left" }, [
                              _vm._v(_vm._s(props.item.description))
                            ]),
                            _c(
                              "td",
                              { staticClass: "text-left" },
                              [
                                _c(
                                  "v-tooltip",
                                  {
                                    attrs: { bottom: "" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function(ref) {
                                            var on = ref.on
                                            return [
                                              _c(
                                                "v-btn",
                                                _vm._g(
                                                  {
                                                    attrs: {
                                                      disabled:
                                                        _vm.$store.getters[
                                                          "Ajax/loading"
                                                        ],
                                                      icon: ""
                                                    },
                                                    nativeOn: {
                                                      click: function($event) {
                                                        return _vm.addAuthItem(
                                                          props.item
                                                        )
                                                      }
                                                    }
                                                  },
                                                  on
                                                ),
                                                [_c("v-icon", [_vm._v("add")])],
                                                1
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  },
                                  [
                                    _vm._v(
                                      " " + _vm._s(_vm.$t("global.add")) + " "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ])
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            )
          ],
          1
        ),
        _c(
          "v-card",
          [
            _c(
              "v-card-actions",
              [
                _c("v-spacer"),
                _c(
                  "v-btn",
                  {
                    attrs: { color: "blue darken-1", text: "" },
                    nativeOn: {
                      click: function($event) {
                        return _vm.cancel()
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("global.cancel")))]
                ),
                _c(
                  "v-btn",
                  {
                    attrs: {
                      disabled: _vm.$store.getters["Ajax/loading"],
                      color: "blue darken-1",
                      text: ""
                    },
                    nativeOn: {
                      click: function($event) {
                        return _vm.save()
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("global.save")) + " ")]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }